<template>
  <svg xmlns="http://www.w3.org/2000/svg" version="1.0" viewBox="0 0 48 48">
    <path
      fill="#CFD8DC"
      d="M5,38V14h38v24c0,2.2-1.8,4-4,4H9C6.8,42,5,40.2,5,38z"
    />
    <path
      fill="#F44336"
      d="M43,10v6H5v-6c0-2.2,1.8-4,4-4h30C41.2,6,43,7.8,43,10z"
    />
    <path
      fill="#B71C1C"
      d="M33 7A3 3 0 1 0 33 13 3 3 0 1 0 33 7zM15 7A3 3 0 1 0 15 13 3 3 0 1 0 15 7z"
    />
    <path
      fill="#B0BEC5"
      d="M33 3c-1.1 0-2 .9-2 2v5c0 1.1.9 2 2 2s2-.9 2-2V5C35 3.9 34.1 3 33 3zM15 3c-1.1 0-2 .9-2 2v5c0 1.1.9 2 2 2s2-.9 2-2V5C17 3.9 16.1 3 15 3z"
    />
    <g>
      <path
        fill="#B0BEC5"
        d="M13 21H19V27H13zM21 21H27V27H21zM29 21H35V27H29zM13 29H19V35H13zM21 29H27V35H21z"
      />
    </g>
    <path fill="#F44336" d="M29 29H35V35H29z" />
    <title v-if="title !== ''">{{ title }}</title>
  </svg>
</template>

<script>
export default {
  name: "PlannerIcon",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
